import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';

export default () => (
  <SectionContainer
    id='physician-disability-insurance-intro'
    backgroundVariant='lightA'
    themeType='lightTheme'
    moduleName='intro-module'
    moduleVariation='A'>
    <Row align='center'>
      <Col
        align='center'
        medium={8}>
        <Typography
          component='h2'
          nextElement='typography'>
          What is disability insurance for physicians <WidowBlock>and dentists&#63;</WidowBlock>
        </Typography>
        <Typography
          align='left'
          nextElement='typography'>
          You&#39;ve made a significant investment in your career, and your unique capabilities are the most important financial asset you have to earn a living. Unlike other professional careers, an injury or illness can adversely affect your ability to perform your job. That&#39;s why it&#39;s important to have the right disability coverage in case the unexpected happens and you&#39;re not able to do the work you love.
        </Typography>
        <Typography
          align='left'
          nextElement='button'>
          We&#39;ve designed our policies to give you flexibility and choice that can help meet your unique needs. Whether you want to stay in your practice or start something new, you can rest easy knowing that if you experience a covered disability, you&#39;ll be able to help cover your daily expenses as well as keep your lifestyle and your financial plan on track.
        </Typography>
        <Link
          id='physician-disability-insurance-intro-section-get-started-link'
          variant='buttonLinkPrimary'
          linkUrl='/find-a-financial-advisor/'
          ariaLabel='Get started with a financial advisor'>
          Get started
        </Link>
      </Col>
    </Row>
  </SectionContainer>
);
